// swish'd — extraction hash for idempotency
// hash = SHA256( normalized_name + "|" + (price ?? "null") + "|" + (vintage ?? "null") )
// Vintage is part of the hash because the same wine name from a different year
// is meaningfully different (Sancerre 2020 vs Sancerre 2021).
//
// Uses Web Crypto API (built into all modern browsers, no dep).
// Returns a hex string. Async because crypto.subtle is async.

import { normalizeDrinkKey } from './supabaseStorage';

export async function computeExtractionHash({ name, price, vintage }) {
  const norm = normalizeDrinkKey(name || '');
  const priceStr = (price === null || price === undefined || Number.isNaN(price)) ? 'null' : String(price);
  const vintageStr = (vintage === null || vintage === undefined || Number.isNaN(vintage)) ? 'null' : String(vintage);
  const input = `${norm}|${priceStr}|${vintageStr}`;
  const buf = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest('SHA-256', buf);
  return Array.from(new Uint8Array(digest))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}
